import { createFileRoute } from "@tanstack/react-router";

import FileUploadsAdmin from "@/components/FileUploadsAdmin";

// Generated to match `src/app/admin/file-uploads/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/file-uploads")({
  component: FileUploadsAdmin,
});
